import { render } from "./AppContextMenu.vue?vue&type=template&id=870e72f4"
import script from "./AppContextMenu.vue?vue&type=script&lang=js"
export * from "./AppContextMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__